import React from "react";
import {
  BsPerson,
  BsJournalText,
  BsListCheck,
  BsClockHistory,
} from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";

function BottomNavbar() {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: "/dashboard", routes: ["/dashboard", "/jadwal", "/izin"], label: "Presensi", icon: <BsListCheck /> },
    { path: "/riwayat", routes: ["/riwayat"], label: "Riwayat", icon: <BsClockHistory /> },
    { path: "/jurnal", routes: ["/jurnal", "/jurnal-harian", "/jurnal-mingguan", "/input-jurnal", "/input-jurnal-mingguan"], label: "Jurnal", icon: <BsJournalText /> },
    { path: "/akun", routes: ["/akun"], label: "Akun", icon: <BsPerson /> },
  ];

  return (
    <nav className="app-bottom-nav" aria-label="Navigasi siswa">
      {navItems.map((item) => {
        const isActive = item.routes.includes(location.pathname);
        return (
          <button
            key={item.path}
            type="button"
            className={`app-bottom-nav-item ${isActive ? "active" : ""}`}
            aria-current={isActive ? "page" : undefined}
            onClick={() => navigate(item.path)}
          >
            {item.icon}
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default BottomNavbar;
